import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { notificationsDisplayed, fetchNotifications } from '../state/actions';
import { StateType } from '../../../state/state.types';

const mapState = ({ notifications }: StateType) => ({
  notifList: notifications.notifList,
});

const mapDispatch = (dispatch: ThunkDispatch<{}, {}, AnyAction>) => ({
  async onDisplayed(lastNotifShownId: number) {
    await dispatch(notificationsDisplayed(lastNotifShownId));
  },
  async onLoad() {
    await dispatch(fetchNotifications());
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
